import type {SessionBridgeResult} from './session-bridge-result'
import {submitSessionBridgeToNewPortal} from './submit-session-bridge-to-new-portal'

export function navigateToMigratedRouteOnNewPortal(legacyPath: string, search?: string, options?: {forceRedirect?: boolean}): SessionBridgeResult {
  return submitSessionBridgeToNewPortal({legacyPath, search, forceRedirect: options?.forceRedirect})
}
